import { Injectable } from '@angular/core';
import { SkippableErrorHandlerModel } from './skippable-error-handler.interface';

@Injectable({ providedIn: 'root' })
export class ChunkLoadErrorHandler implements SkippableErrorHandlerModel {
  handleError(error: Error): false | void {
    if (isChunkLoadError(error)) {
      console.error('Error loading chunk, refreshing');

      window.location.reload();
      return false;
    }
  }
}

const isChunkLoadError = (error: Error): boolean =>
  error instanceof Error && (/ChunkLoadError/.test(error.name) || /ChunkLoadError/.test(error.message));
